var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-container',[_c('el-timeline',[_vm._l((_vm.list),function(item){return [_c('el-timeline-item',{attrs:{"timestamp":_vm._f("date")(item),"placement":"top"}},[_c('el-card',[_c('div',[_vm._v(_vm._s(_vm._f("content")(item)))]),_c('small',[_vm._v("Tag: "+_vm._s(item))])])],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }